import ColorPerFeatureStyler from "./colorPerFeatureStyler";
import CompoundStyler from "./compoundStyler";
import ConditionalStyler from "./conditionalStyler";
import SingleStyler from "./singleStyler";
import TerritoryPointStyler from "./territoryPointStyler";
import ThematicStyler from "./thematicStyler";

type IStylerModule = {
    getStyle: (styler, style, feature, layerViewInfo) => any,
    getPaddingPx: (styler) => number[],
    hasDirect: (styler) => boolean,
    hasOverlays: (styler) => boolean,
    getHideFeaturesCriteria: (styler) => any
};

export default class StylerModule {
    private stylerModule: Map<string, IStylerModule>;

    constructor() {
        this.stylerModule = new Map();
        this.stylerModule.set('ColorPerFeatureStyler', new ColorPerFeatureStyler());
        this.stylerModule.set('CompoundStyler', new CompoundStyler(this));
        this.stylerModule.set('ConditionalStyler', new ConditionalStyler());
        this.stylerModule.set('SingleStyler', new SingleStyler());
        this.stylerModule.set('TerritoryPointStyler', new TerritoryPointStyler());
        this.stylerModule.set('ThematicStyler', new ThematicStyler());
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    private getStylerModule(styler): IStylerModule {
        const stylerModule = this.stylerModule.get(styler.$type);
        if (!stylerModule) {
            throw new Error("Invalid styler type: " + styler.$type);
        }

        return stylerModule;
    }

    /**
     * 
     * @param styler 
     * @param style 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    getStyle(styler, style, feature, layerViewInfo) {
        return this.getStylerModule(styler).getStyle(styler, style, feature, layerViewInfo);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getPaddingPx(styler): number[] {
        return this.getStylerModule(styler).getPaddingPx(styler);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasDirect(styler): boolean {
        return this.getStylerModule(styler).hasDirect(styler);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasOverlays(styler): boolean {
        return this.getStylerModule(styler).hasOverlays(styler);
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getHideFeaturesCriteria(styler) {
        return this.getStylerModule(styler).getHideFeaturesCriteria(styler);
    }
}